﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import type { SoPNLConsilioTheme } from "~jrad/Styling/SoPNLConsilioTheme";
import { SoPThemeConstantsV2 } from "~irad/Styling/SoPTheme2025/Sop2025ThemeConstantsV2";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export default createUseStyles((theme: SoPNLConsilioTheme) => ({
    pageContainer: {
        margin: "0 auto",
        padding: "0 42px",
        width: "100%",
        maxWidth: "996px",
    },
    errorMessage: {
        color: "red",
        fontFamily: theme.constants.defaultFont,
        fontSize: "18px",
        fontWeight: "normal",
        whiteSpace: "pre-line",
    },
    introHeader: {
        color: theme.constants.textColor,
        fontFamily: theme.constants.headerFont,
        fontSize: "40px",
        fontWeight: "normal",
    },
    introDesc: {
        ...SoPThemeConstantsV2.Typography.Paragraph,
        color: theme.constants.textColor,
        fontFamily: theme.constants.defaultFont,

        whiteSpace: "pre-line",

        "& a": {
            color: "#009fdf",

            "&:hover": {
                color: "#002d72",
            },
        },
    },
    introDivider: {
        height: 0,
        width: "100%",
        borderTop: "1px solid #777777",
        borderBottom: "none",
        margin: "18px 0",
    },
    overlayDescription: {
        fontFamily: theme.constants.defaultFont,
        fontSize: "16px",
    },
}));
